<template>
    <div style="padding-top: 80px">
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Calificar Agentes</p>
            </v-card-title>
            <v-card-text class="pa-5 pt-4">
                <br />
                <v-row>
                    <v-col md="6" offset-md="3">
                        <span style="color: black; text-align: center;">Nota:</span>
                        <div>Se enlista los Operadores activos, con un reporte generado al azar que puede calificar para
                            el mes anterior correspondiente.
                        </div>
                    </v-col>
                </v-row>

            </v-card-text>
        </v-card>
        <v-card class=" mt-2">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Apartados y Descripción </p>
            </v-card-title>
            <v-card-text>
                <v-row v-if="agentes.length > 0">
                    <v-col v-for="(item, index) in agentes" :key="index" cols="12" sm="6" md="4" lg="3">
                        <v-card class="AgenteCard">
                            <v-card-title class="pa-5 pb-3 primary">
                                <p style="color: white; font-size:15px">{{ item.usnom }}</p>
                                <v-spacer></v-spacer>
                                <template v-if="item.docid == '' && item.showCambio == 1">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="mx-2" small fab v-on="on" v-bind="attrs"
                                                @click="CambiarReporte(item)" :loading="loadingExcel"
                                                :disabled="loadingExcel">
                                                <v-icon dark>
                                                    mdi-file-restore-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Cambiar Reporte</span>
                                    </v-tooltip>
                                </template>
                            </v-card-title>
                            <v-card-text>
                                <div class="datosDivAgente">
                                    <vs-list>
                                        <vs-list-item title="Reporte:"
                                            :subtitle="item.nrreporte + '-' + item.svindice"></vs-list-item>
                                        <vs-list-item title="Asistencia:" :subtitle="item.ainombre"></vs-list-item>
                                        <vs-list-item title="Fecha reporte:"
                                            :subtitle="item.svfhreporte"></vs-list-item>
                                        <vs-list-item title="Llamada: " :subtitle="item.docarchivo">
                                            <v-tooltip top v-if="item.docid == ''">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon dark v-on="on" v-bind="attrs" style="font-size: 20;"
                                                        :loading="false" color="#536DFE"
                                                        @click="dialogAgregarLlamada(item)">
                                                        <v-icon color>mdi-upload</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Agregar Llamada</span>
                                            </v-tooltip>
                                        </vs-list-item>
                                        <vs-list-item title="Seleccionar Agente:">
                                            <v-checkbox v-model="item.selectAgente" :value="item.selectAgente"
                                                :disabled="item.disabledCheck" v-if="item.proceso == 0"></v-checkbox>
                                            <v-icon large color="warning" v-if="item.proceso == 1">
                                                mdi-check
                                            </v-icon>
                                            <v-icon large color="#3CD4A0" v-if="item.proceso == 2">
                                                mdi-check-all
                                            </v-icon>
                                        </vs-list-item>
                                    </vs-list>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-row v-if="showCargando" class="mt-2 py-5 align-center justify-center">
                        <v-col cols="12" class="text-center">
                            <v-progress-circular :size="70" :width="7" color="primary" indeterminate>
                            </v-progress-circular>
                        </v-col>
                    </v-row>
                    <v-row v-else class="mt-2 py-5 align-center justify-center">
                        <v-col cols="12" class="text-center">
                            <h5 style="text-align: center;">No hay agentes por calificar</h5>
                        </v-col>
                    </v-row>
                </v-row>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;" v-if="!showCargando">
                <v-row justify="center" class="mb-8">
                    <v-btn class="ma-2" color="#536DFE" :disabled="!disabledSave" style="color:white"
                        @click="Inciar()">Iniciar
                        Proceso</v-btn>
                </v-row>
            </v-card-actions>

        </v-card>
        <v-card class=" mt-2" id="Agentes" v-if="showAgentesCalif">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Detalle de Evaluación </p>
                <v-spacer></v-spacer>
                <template v-if="showExcel">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" small fab v-on="on" v-bind="attrs" @click="DescargarExcel()"
                                :loading="loadingExcel" :disabled="loadingExcel">
                                <v-icon dark>
                                    mdi-microsoft-excel
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Descargar Excel</span>
                    </v-tooltip>
                </template>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col md="6" offset-md="3">
                        <span style="color: black; text-align: center;">Nota:</span>
                        <div class="custom-list">Clasifique el desempeño de acuerdo a la siguiente escala:
                            <ol start="0">
                                <li>Sin argumentos para ser evaluado.</li>
                                <li>Muestra un nivel pésimo en su desempeño.</li>
                                <li>Requiere mejorar su desempeño.</li>
                                <li>Muestra un nivel medio de desempeño.</li>
                                <li>Muestra simplemente un buen desempeño.</li>
                                <li>Cumple al 100% y un poco más.</li>
                            </ol>
                        </div>
                    </v-col>
                </v-row>
                <v-row class="pa-4" justify="space-between">
                    <v-col cols="12" md="3">
                        <v-treeview :items="[agentesCalificados]" :active.sync="active" :open.sync="open" activatable
                            color="primary" open-on-click transition @update:active="handleClick">
                            <!-- Primer nivel -->
                            <template v-slot:prepend="{ item }">
                                <div v-if="!item.children">
                                    <v-icon v-if="item.proceso === 1" color="warning">mdi-check</v-icon>
                                    <v-icon v-if="item.proceso === 2" color="#3CD4A0">mdi-check-all</v-icon>
                                </div>
                            </template>
                        </v-treeview>
                    </v-col>
                    <v-divider vertical></v-divider>

                    <v-col class="d-flex text-center">
                        <v-scroll-y-transition mode="out-in">
                            <div v-if="selected == null" class="text-h6 grey--text text--lighten-1 font-weight-light"
                                style="align-self: center;">
                                Seleccione un Agente
                            </div>
                            <v-card v-else :key="selected.id" class="pt-6 mx-auto" flat width="100%">
                                <v-card-title class="justify-center primary">
                                    <v-toolbar-title id="titulocard">Evaluación Agente</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="mx-2" small fab v-on="on" v-bind="attrs"
                                                @click="MostrarRetroalimentacion()">
                                                <v-icon dark>
                                                    mdi-clipboard-check
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Ver Retroalimentación</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="mx-2" small fab v-on="on" v-bind="attrs"
                                                @click="ModalRecalificar()" v-show="showBoton">
                                                <v-icon dark>
                                                    mdi-restart-alert
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Recalificar</span>
                                    </v-tooltip>
                                </v-card-title>
                                <v-card-text>
                                    <v-avatar size="88">
                                        <v-img src="https://ausa.com.mx/img/Images/perfil.png"></v-img>
                                    </v-avatar>
                                    <h3 class="text-h5 mb-2">
                                        {{ selected.name }}
                                    </h3>
                                    <div class="blue--text mb-2">
                                        {{ selected.reporte }}
                                    </div>
                                    <div class="blue--text subheading font-weight-bold">
                                        <!-- <v-btn class="mx-2" small fab dark color="indigo">
                                            <v-icon dark>
                                                mdi-play-circle-outline
                                            </v-icon>
                                        </v-btn> -->
                                        <v-col cols="12" col-md="8">
                                            <div id="escucharModal" class="text-center">
                                            </div>
                                        </v-col>
                                    </div>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-text v-if="this.selectAgente != null">
                                    <div class="mt-1 ml-1">
                                        <v-form ref="form" v-model="valid" lazy-validation>
                                            <vs-list v-for="(agente, index) in selectAgente" :key="index">
                                                <template
                                                    v-if="index === 0 || agente.apartado !== selectAgente[index - 1].apartado">
                                                    <vs-list-header :title="agente.apartado"
                                                        id="apartado"></vs-list-header>
                                                </template>
                                                <vs-list-item :title="agente.pregunta" v-if="agente.pccaid != 24">
                                                    <div class="mt-4">
                                                        <v-text-field label="Calificar" outlined dense
                                                            @keypress="validarRegex($event, 'N')" id="inputCalif"
                                                            :rules="califRules" required v-model="agente.calificacion"
                                                            v-if="agente.proceso != 2 && agente.editar">
                                                        </v-text-field>
                                                        <div id="calificacion" v-else
                                                            :style="{ color: agente.colorCalificacion }">
                                                            {{ agente.calificacion }}
                                                        </div>
                                                    </div>
                                                </vs-list-item>
                                                <template v-else>
                                                    <template v-if="agente.editar && agente.proceso != 2">
                                                        <v-textarea auto-grow outlined rows="3" row-height="25"
                                                            v-model="agente.motivo" :counter="250" :maxlength="250"
                                                            :rules="areaRules"></v-textarea>
                                                    </template>
                                                    <template v-else>
                                                        <vs-list-item :subtitle="agente.motivo"
                                                            id="area"></vs-list-item>
                                                    </template>
                                                </template>

                                            </vs-list>
                                            <vs-list>
                                                <vs-list-item title="CALIFICACIÓN: " id="califFinal">
                                                    <div id="calificacionFinal"
                                                        :style="getCalificacionStyle(selected.calificacionFinal)">{{
                                                            selected.calificacionFinal }}</div>
                                                </vs-list-item>
                                            </vs-list>
                                        </v-form>
                                    </div>
                                </v-card-text>
                                <v-card-actions class="justify-center" v-if="selected.proceso == 1">
                                    <v-btn color="primary" :disabled="btndisabledCalificaciones"
                                        @click="GuardarCalificaciones()">Aceptar</v-btn>
                                    <v-btn @click="LimpiarCalificaciones()" color="default"
                                        :disabled="btndisabledCalificaciones">Limpiar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-scroll-y-transition>
                    </v-col>
                </v-row>
            </v-card-text>

        </v-card>

        <v-dialog transition="dialog-top-transition" persistent max-width="600" v-model="showDialogLlamada">
            <v-form ref="formLlamada" v-model="validLlamada" lazy-validation>
                <v-card>
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Agregar Llamada</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text>
                        <v-row class="mb-8" style="margin-bottom: 0px !important; margin-top: 0px;">
                            <v-col md="12" cols="12">
                                <span style="font-weight: bold;">Tipo Llamada:</span>
                                <br />
                                <span style="font-weight: bold; font-size: large;">Toma de Reporte</span>
                            </v-col>
                        </v-row>
                        <v-row class="mb-8" style="margin-bottom: 0px !important; margin-top: 0px;">
                            <v-col md="12" cols="12">
                                <span style="font-weight: bold;">Reporte:</span>
                                <br />
                                <span style="font-weight: bold; font-size: large;">{{ reporteSelect.nrreporte + '-' +
                                    reporteSelect.svindice }}</span>
                            </v-col>
                        </v-row>
                        <v-row class="mb-8" style="margin-bottom: 0px !important; margin-top: 0px;">
                            <v-col md="12" cols="12">
                                <vs-list-item title="Nombre del archivo:"></vs-list-item>
                                <v-text-field v-model="nomArchivo" outlined dense :error-messages="validation.errorRuta"
                                    max="100"></v-text-field>
                            </v-col>

                            <!--  <v-col md="12" cols="12">
                                <vs-list-item title="Selecciona archivo:"></vs-list-item>
                                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                                    @vdropzone-sending="sendingParameters"
                                    @vdropzone-files-added="addedFiles"></vue-dropzone>
                                <span style="color: red; display: none" id="dropzError"> Debe agregar al
                                    menos un archivo </span>
                            </v-col> -->
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" :disabled="btndisabledLlamada" @click="GuardarLlamada()"
                            :loading="loadingLlamada">Aceptar</v-btn>
                        <v-btn @click="LimpiarDialogLlamada()" color="default"
                            :disabled="btndisabledLlamada">Limpiar</v-btn>
                        <v-btn @click="CerrarDialogllamada()" color="secondary"
                            :disabled="btndisabledLlamada">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog transition="dialog-top-transition" persistent max-width="600" v-model="modalRecalificarLlamada">
            <v-form ref="formRecalifcar" v-model="validRecalificar" lazy-validation>
                <v-card>
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Recalifcar Reporte</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text>
                        <v-row class="mb-8" style="margin-bottom: 0px !important; margin-top: 0px;">
                            <v-col md="12" cols="12">
                                <span style="font-weight: bold;">Reporte:</span>
                                <br />
                                <span style="font-weight: bold; font-size: large;" v-if="this.selected != null">{{
                                    this.selected.reporte }}</span>
                            </v-col>
                        </v-row>
                        <v-row class="mb-8" style="margin-bottom: 0px !important; margin-top: 0px;">
                            <v-col md="12" cols="12">
                                <span>Para recalificar este reporte necesita escribir la oración: </span>
                                <span style="font-weight: bold; font-style: italic;">La llamada esta mal
                                    clasificada</span>
                                <v-text-field v-model="oracionValida" outlined dense :error-messages="valiOracion"
                                    max="100" @paste="preventPaste" @keydown="preventCtrlV"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" :disabled="btndisabledRecalificar"
                            @click="GuardarRecalifcar()">Aceptar</v-btn>
                        <v-btn @click="LimpiarDialogRecalificar()" color="default"
                            :disabled="btndisabledRecalificar">Limpiar</v-btn>
                        <v-btn @click="CerrarDialogRecalificar()" color="secondary"
                            :disabled="btndisabledRecalificar">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog transition="dialog-top-transition" persistent max-width="1200" v-model="showRetro"
            style="z-index: 10000;">
            <v-card>
                <v-card-title class="justify-center primary">
                    <v-toolbar-title id="titulocard">Retroalimentación para el agente</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="red accent-3" icon text @click="showRetro = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-row class="mb-8" style="margin-bottom: 0px !important; margin-top: 0px;">
                    <v-col md="12" cols="12">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            Pregunta
                                        </th>
                                        <th class="text-left">
                                            Calificacion
                                        </th>
                                        <th class="text-left">
                                            Motivo
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in motivosCalif" :key="item.name">
                                        <td>{{ item.Pregunta }}</td>
                                        <td>{{ item.Calificacion }}</td>
                                        <td>{{ item.Motivo }}</td>

                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-card-text>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog transition="dialog-top-transition" persistent max-width="600" v-model="modalCambiarReporte">
            <v-form ref="formRecalifcar" v-model="validCambioReporte" lazy-validation>
                <v-card>
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Cambiar Reporte</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text>
                        <v-row class="mb-8" style="margin-bottom: 0px !important; margin-top: 0px;">
                            <v-col md="12" cols="12">
                                <span style="font-weight: bold;">Reporte:</span>
                                <br />
                                <span style="font-weight: bold; font-size: large;"
                                    v-if="this.selectCambioReporte != null">{{
                                        this.selectCambioReporte.nrreporte }} - {{ this.selectCambioReporte.svindice
                                    }}</span>
                            </v-col>
                        </v-row>
                        <v-row style="padding-bottom: 0px;">
                            <v-col md="6" cols="12">
                                <span style="font-weight: bold;">Nuevo reporte: </span>
                                <v-text-field v-model="reporte" outlined dense maxlength="10"
                                    @keypress="validarRegex($event, 'N')" :disabled="aleatorio"
                                    :error="validReporte"></v-text-field>
                            </v-col>
                            <v-col md="6" cols="12">
                                <!--  <v-switch v-model="aleatorio" inset label="Generar reporte aleatoriamente"></v-switch> -->
                                <v-checkbox v-model="aleatorio" label="Generar reporte aleatoriamente" color="primary"
                                    :error="validReporte"></v-checkbox>
                            </v-col>

                        </v-row>
                        <v-row style="padding-top: 0px;" v-if="validReporte">
                            <v-col cols="12">
                                <span style="color: #FF5C93;">Es necesario que ingrese el reporte o que marque la opción
                                    de reporte aleatorio</span>
                            </v-col>
                        </v-row>
                        <v-row class="mb-8" style="margin-bottom: 0px !important; margin-top: 0px;">
                            <v-col md="12" cols="12">
                                <span>Para cambiar este reporte necesita escribir la oración: </span>
                                <span style="font-weight: bold; font-style: italic;">El reporte no se puede calificar
                                </span>
                                <v-text-field v-model="oracionValida" outlined dense :error-messages="valiOracion"
                                    maxlength="35" @paste="preventPaste" @keydown="preventCtrlV"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" :disabled="btndisabledCambio"
                            @click="GuardarCambioReporte()">Aceptar</v-btn>
                        <v-btn @click="LimpiarDialogCambioReporte()" color="default"
                            :disabled="btndisabledCambio">Limpiar</v-btn>
                        <v-btn @click="CerrarDialogCambioReporte()" color="secondary"
                            :disabled="btndisabledCambio">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Calidad from "@/services/Calidad/Calidad.service.js";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import vue2Dropzone from "vue2-dropzone";
import Archivos from '@/services/Archivos/Archivos.service.js';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        vueDropzone: vue2Dropzone,
    },
    data() {
        return {
            active: [],
            open: [],
            users: [],

            //---------------//
            disabledSave: true,
            showDialogLlamada: false,
            validLlamada: true,
            btndisabledLlamada: false,
            btndisabledCalificaciones: false,
            showCargando: true,
            agentes: [],
            dropzoneOptions: {
                maxFiles: 1,
                paramName: "file",
                url: `${this.$store.state.domain.domainNameForApi}Archivos/FileUploadProcess`,
                thumbnailWidth: 200,
                acceptedFiles: "audio/mpeg,audio/mp4,audio/wav,.mp3,.m4a",
                autoProcessQueue: false,
                chunkSize: 5242880, // 5 MB
                chunking: true,
                forceChunking: true,
                parallelUploads: 1,
                uploadMultiple: false,
                parallelChunkUploads: false,
                timeout: null,
                addRemoveLinks: true,
                dictRemoveFile: 'Eliminar',
                dictDefaultMessage: '<span class="dropzone-divided-message"> <span class="dropzone-bold-large">Seleccione sus archivos.</span><br>Arrastre aquí sus archivos.</span>',
                retryChunks: true,
                retryChunksLimit: 3,
                dictInvalidFileType: "No puedes subir archivos de este tipo",
                dictMaxFilesExceeded: 'No puede cargar más archivos.',
                chunksUploaded: async function (file, done) {
                    await window.FileUploadContext.successFile();
                    await done();
                },
                init: function () {
                    this.on("error", function (file, errorMessage) {
                        if (errorMessage === "No puedes subir archivos de este tipo") {
                            this.removeFile(file);
                        }
                    });
                },
            },
            agentesCalificados: {
                name: 'Agentes',
                children: []
            },
            selected: null,
            nomArchivo: '',
            validation: {
                errorRuta: '',
            },
            reporteSelect: [],
            valid: true,
            califRules: [
                v => v !== '' && v !== null && v !== undefined || 'Calificación requerida',
                v => (v >= 0 && v <= 5) || 'Debe estar entre 0 y 5'
            ],
            areaRules: [
                v => v !== '' && v !== null && v !== undefined || 'Área de mejora requerida',
            ],
            contadorSol: 0,
            showAgentesCalif: false,
            calificacionesArray: [],
            datos: null,
            showRetro: false,
            motivosCalif: [],
            numReportes: 0,
            loadingExcel: false,
            nombreArchivo: '',
            showExcel: false,
            datosValidar: [],
            reporteValidar: null,
            contadorerrores: 0,
            selectAgente: null,
            modalRecalificarLlamada: false,
            validRecalificar: true,
            btndisabledRecalificar: false,
            oracionValida: '',
            valiOracion: '',
            showBoton: false,
            loadingLlamada: false,
            /////
            modalCambiarReporte: false,
            validCambioReporte: true,
            selectCambioReporte: null,
            btndisabledCambio: false,
            reporte: '',
            aleatorio: false,
            validReporte: false
        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),

    },

    watch: {
        'oracionValida'(val) {
            if (val != '') {
                this.valiOracion = ''
            }
        },
        'nomArchivo'(val) {
            if (val != '') {
                this.validation.errorRuta = '';
            }
        },
        agentes: {
            handler(newVal) {
                let contador = 0
                // Encuentra los cambios en `checkAutorizado`
                newVal.forEach((item, index) => {
                    if (item.selectAgente == true) {
                        contador++;
                    }
                });
                this.disabledSave = contador > 0 ? true : false;
                // Actualiza los valores previos
            },
            deep: true,
        },
        async 'contadorSol'(val) {
            if (val > 0) {
                if (val == this.numReportes) {
                    let correctos = 0
                    correctos = val - this.contadorerrores
                    this.$swal({
                        position: 'center',
                        icon: 'success',
                        title: 'Proceso Terminado. ',
                        //text: 'Agentes calificados correctamente',
                        html: `Agentes calificados correctamente ${correctos} de ${this.numReportes}. Hubo ${this.contadorerrores} que no se pudieron calificar.`,
                        showConfirmButton: true,
                    });
                    await this.ObtenerAgentesCalificados();
                    await this.ObtenerAllAgentes();
                }
            }
        },
        selectAgente: {
            handler(newVal, oldVal) {
                if (!oldVal) return; // Evita errores si oldVal es null/undefined
                newVal.forEach((calif) => {
                    // Busca el objeto con `pccaid === 15`
                    if (calif.pccaid == 15 && calif.proceso == 1 && (calif.calificacion === 0 || calif.calificacion === "0")) {
                        this.showBoton = true;
                    } else if (calif.pccaid == 15 && calif.proceso == 1 && !(calif.calificacion === 0 || calif.calificacion === "0")) {
                        this.showBoton = false;
                    }
                });
            },
            deep: true, // Necesario para observar cambios internos en arrays/objetos
        },
        'aleatorio'(val) {
            if (val == true) {
                this.reporte = ''
            }
        }
    },

    methods: {
        preventPaste(event) {
            event.preventDefault();
        },
        preventCtrlV(event) {
            // Prevenir Ctrl+V o Cmd+V
            if ((event.ctrlKey || event.metaKey) && event.key === 'v') {
                event.preventDefault();
            }
        },
        async handleClick(item) {
            let agenteSeleccionado = this.agentesCalificados.children.find(agente => agente.id === item[0]);
            this.selected = agenteSeleccionado
            this.showBoton = this.selected.showBoton;
            let response = await Calidad.ObtenerAgenteCalificado(this, this.selected.nrreporte, this.selected.svindice)
            this.selectAgente = response;
            this.datos = null;
            const modal = document.getElementById("escucharModal");
            if (modal) {
                modal.innerHTML = '';
            }
            this.EscucharAudio(this.selected);
        },
        async EscucharAudio(datos) {
            /* this.datos = {
                nrreporte: datos.nrreporte,
                svindice: datos.svindice
            } */
            /* var datosReporte = new FormData();
            datosReporte.append("nrreporte", datos.nrreporte);
            datosReporte.append("svindice", datos.svindice); */
            //let dir = await Archivos.ObtenerDireccion(this.datos, datos.docid, datos.docpaginas);
            let dir = await Archivos.ObtenerDireccionAgentes(this, this.selected.nrreporte, this.selected.svindice, this.selected.docid);
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", "CalificarAgentes");
            formData.append("laaccion", "Escuchó Audio");
            formData.append("lacaracteristicas", this.selected.nrreporte + '-' + this.selected.svindice);
            formData.append("lanombre", dir.archivo);
            formData.append("ladestinatario", "");
            await Archivos.AlmacenarVisitas(formData);
            this.cargandoAudio = false;

            if (dir.archivo !== null) {
                let audio = document.createElement('audio');
                audio.style.margin = '0 auto';
                audio.src = dir.watch;
                audio.controls = true;
                audio.autoplay = false;
                audio.controlsList = "nodownload";
                document.getElementById('escucharModal').appendChild(audio);
                this.Titulo = datos.docarchivo;
            } else {
                this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: dir.msg,
                    showConfirmButton: true,
                    confirmButtonColor: '#536DFE',
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false,
                });
            }
        },
        addedFiles() {
            document.getElementById("dropzError").style.display = "none";
        },
        async sendingParameters(file, xhr, formData) {
            if (this.contador > 0) {
                let index = 0;
                let jsonData = JSON.parse(this.xhrResponses[index].response);
                formData.append("data", jsonData.data);
            }
            formData.append("nrreporte", this.nrreporte);
            formData.append("svindice", this.svindice);
            formData.append("doclave", this.tipoLlamada.doclave.doclave);
            formData.append("url", window.location.href);
            formData.append("filename", file.name);
            formData.append("dzId", file.upload.uuid);
            if (file.upload.chunked) {
                this.fileChunked = true;
                formData.append("chunkedFile", true);
                formData.append("chunkIndex", file.upload.chunks[this.contador].dataBlock.chunkIndex);
                formData.append("chunkSize", file.upload.chunks[this.contador].dataBlock.data.size);
            }
            this.xhrResponses.push(xhr);
            this.contador++;
        },
        async dialogAgregarLlamada(item) {
            this.reporteSelect = []
            this.showDialogLlamada = true;
            this.reporteSelect = item;
            this.loadingLlamada = false;
            this.btndisabledLlamada = false;
        },
        LimpiarDialogLlamada() {
            /* this.$refs.myVueDropzone.removeAllFiles();
            document.getElementById("dropzError").style.display = "none"; */
            this.validation.errorRuta = '';
            this.nomArchivo = '';
        },
        CerrarDialogllamada() {
            this.validation.errorRuta = '';
            this.nomArchivo = '';
            this.showDialogLlamada = false;
            /*  this.$refs.myVueDropzone.removeAllFiles();
             document.getElementById("dropzError").style.display = "none"; */
        },
        async GuardarLlamada() {
            if (this.nomArchivo == "") {
                this.validation.errorRuta = 'campo requerido';
            } else {
                //Validamos el nombre del archivo
                this.loadingLlamada = true;
                this.btndisabledLlamada = true;
                this.nomArchivo = this.nomArchivo.trim();
                let response = await Calidad.BuscarLlamada(this, this.reporteSelect.nrreporte, this.reporteSelect.svindice, this.nomArchivo);
                if (response.length > 0) {
                    this.agentes.forEach(async agente => {
                        if (agente.nrreporte == this.reporteSelect.nrreporte && agente.svindice == this.reporteSelect.svindice) {
                            agente.disabledCheck = false;
                            agente.docid = response[0].docid;
                            agente.docarchivo = response[0].docarchivo;
                            agente.rutaarchivo = response[0].rutaCarpeta;
                            agente.docpaginas = response[0].docpaginas;
                        }
                        await this.LimpiarDialogLlamada()
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se asignó la llamada correctamente',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 2500,
                        }).then(async () => {
                            this.CerrarDialogllamada()
                        });
                    })
                } else {
                    //this.validation.errorRuta = 'Nombre de archivo incorrecto';
                    //vamos a buscar al bucket
                    let response = await this.ObtenerFechaDia(this.nomArchivo);

                    let busqueda = await Calidad.BuscarArchivoBucket(this, this.nomArchivo, this.reporteSelect.nrreporte, this.reporteSelect.svindice, this.reporteSelect.uslogin, response.fecha, this.reporteSelect.anio, this.reporteSelect.mes, response.dia)
                    this.loadingLlamada = false;
                    await this.LimpiarDialogLlamada()
                    if (busqueda === "true") {
                        await this.ObtenerAllAgentes();
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se asignó la llamada correctamente',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 2500,
                        }).then(async () => {
                            this.CerrarDialogllamada()
                        });
                    } else if (busqueda === "false") {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Error',
                            text: 'Ocurrio un error, al buscar la llamada. Intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                            showConfirmButton: false,
                            timer: 2500
                        });
                    }

                }
                this.loadingLlamada = false;
                this.btndisabledLlamada = false;
            }
        },
        async Inciar() {
            this.contadorSol = 0;
            this.numReportes = 0;
            this.contadorerrores = 0;

            this.$swal({
                position: "center",
                icon: "info",
                text: "¿Está seguro que desea iniciar el proceso de calificar a los agentes seleccionados?",
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                allowEscapeKey: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    try {
                        let reportesSelect = this.agentes.filter(agente => agente.selectAgente === true);
                        let sinllamda = reportesSelect.docid != 0 ? 0 : 1;
                        this.numReportes = reportesSelect.length
                        this.$swal({
                            title: 'Procesando Llamanda(s)... ',
                            html: `<p id="progress-text">Procesando 0 de ${this.numReportes} llamadas...</p>`,
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            didOpen: async () => {
                                this.$swal.showLoading();
                                const progressText = document.getElementById('progress-text');
                                for (let reporteAg of reportesSelect) {
                                    let response = await Calidad.InciarProcesoAgentes(this, reporteAg.nrreporte, reporteAg.svindice, reporteAg.docid, reporteAg.docpaginas);
                                    if (response && response.jobId) {
                                        await this.monitorProceso(response.jobId, progressText);
                                    } else {
                                        this.contadorerrores++;
                                        this.contadorSol++;
                                        progressText.innerHTML = `Procesando ${this.contadorSol} de ${this.numReportes} llamadas...`;
                                    }
                                }
                            }
                        })
                    } catch (e) {
                        console.log('e', e)
                    }
                }
            })
        },
        validarRegex(evt, tipo) {
            return MetodosGenerales.validarRegex(evt, tipo);
        },
        getCalificacionStyle(calificacion) {
            if (calificacion < 6) {
                return { color: '#FF5C93' }; // Rojo si es menor a 6
            } else if (calificacion >= 6 && calificacion < 8) {
                return { color: '#FFC260' }; // Amarillo si está entre 6 y 8
            } else {
                return { color: '#3CD4A0' }; // Verde si es mayor a 8
            }
        },

        LimpiarCalificaciones() {
            this.$refs.form.reset();
        },
        async GuardarCalificaciones() {
            this.$refs.form.validate()
            if (this.$refs.form.validate()) {
                this.btndisabledCalificaciones = true;
                this.$swal({
                    title: 'Guardando calificaciones... ',
                    html: `Espere un momento, por favor`,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();

                        for (let i = 0; i < this.selectAgente.length; i++) {
                            if (this.selectAgente[i].editar == 1) {
                                let response = await Calidad.GuardarCalificacionesFinales(this, this.selectAgente[i].pccaid, this.selectAgente[i].calificacion, this.selectAgente[i].reaid, this.selectAgente[i].motivo.trim());
                            }
                        }
                        let calif = await Calidad.ActualizarCalificacionFinal(this, this.selected.nrreporte, this.selected.svindice, this.selectAgente[0].reaid);
                        if (calif) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se asignaron correctamente las calificaciones al Agente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                await this.ObtenerAgentesCalificados()
                                await this.ObtenerAllAgentes();

                                let dato = [this.selected.id];
                                await this.handleClick(dato)
                                this.agentes.forEach(agente => {
                                    if (this.selected.nrreporte == agente.nrreporte && this.selected.svindice == agente.svindice) {
                                        agente.reaproceso = 2
                                    }
                                })
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: 'Ocurrio un error, al guardar alguna calificación. Intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: false,
                                timer: 2500
                            });
                        }
                    }
                })
                this.btndisabledCalificaciones = false
            }
        },
        async ObtenerAgentesCalificados() {
            this.showAgentesCalif = false
            this.agentesCalificados.children = await Calidad.AgentesCalificados(this)
            this.showAgentesCalif = this.agentesCalificados.children.length > 0 ? true : false;
            this.agentesCalificados.children.forEach(agente => {
                if (agente.proceso == 2) {
                    this.showExcel = true
                }
            })
        },
        async MostrarRetroalimentacion() {
            let response = await Calidad.ObtenerRetroalimentacion(this, this.selected.nrreporte, this.selected.svindice)
            this.motivosCalif = response;
            this.showRetro = true;
        },
        async ObtenerAllAgentes() {
            this.agentes = await Calidad.ObtenerAgentes(this);
            this.showCargando = false;
            this.disabledSave = this.agentes.every(agente => agente.docarchivo !== "");
            this.agentes.forEach(agente => {
                agente.disabledCheck = agente.disabledCheck == 1 ? true : false;
            })
        },
        async DescargarExcel() {
            this.loadingExcel = true;
            const response = await Calidad.AgentesCalificadosExcel(this);
            let today = moment().format('yyyy-MM-DD');
            this.nombreArchivo = 'AgentesCalificados-' + today.toString();
            await MetodosGenerales.exportToExcel(response, this.nombreArchivo, false, false);
            this.loadingExcel = false;
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'Calificar Agentes');
            formData.append("laaccion", "Descargar Archivo excel");
            formData.append("lacaracteristicas", 'CalificarAgentes');
            formData.append("lanombre", this.nombreArchivo + ".xlsx");
            formData.append("ladestinatario", " ");
            Archivos.AlmacenarVisitas(formData);
        },
        async ModalRecalificar() {
            this.modalRecalificarLlamada = true;
        },
        LimpiarDialogRecalificar() {
            this.valiOracion = '';
            this.oracionValida = '';
        },
        CerrarDialogRecalificar() {
            this.modalRecalificarLlamada = false;
            this.valiOracion = '';
            this.oracionValida = '';
        },
        async GuardarRecalifcar() {
            if (this.oracionValida != '') {
                this.oracionValida = this.oracionValida.trim().toLocaleLowerCase()
                const oracion = 'la llamada esta mal clasificada'
                if (oracion == this.oracionValida) {
                    this.btndisabledRecalificar = true;
                    this.$swal({
                        title: 'Restableciendo calificación... ',
                        html: `Espere un momento, por favor`,
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            let response = await Calidad.RestablecerCalificacion(this, this.selected.nrreporte, this.selected.svindice, this.selected.id);
                            if (response) {
                                this.LimpiarDialogRecalificar();
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se restableció la calificación exitosamente.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {
                                    await this.ObtenerAgentesCalificados()
                                    await this.ObtenerAllAgentes();
                                    this.CerrarDialogRecalificar()
                                    let dato = [this.selected.id];
                                    await this.handleClick(dato)
                                    this.agentes.forEach(agente => {
                                        if (this.selected.nrreporte == agente.nrreporte && this.selected.svindice == agente.svindice) {
                                            agente.reaproceso = 0
                                        }
                                    })
                                });
                            } else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'warning',
                                    title: 'Error',
                                    text: 'Ocurrio un error, al restablecer la calificación. Intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                    showConfirmButton: false,
                                    timer: 2500
                                });
                            }
                        }
                    })
                    this.btndisabledRecalificar = false;

                } else {
                    this.valiOracion = 'oración incorrecta'
                }
            } else {
                this.valiOracion = 'campo requerido'
            }
        },
        ObtenerFechaDia(nombreArchivo) {
            let fecha = null;

            // Expresión regular para el primer formato (Fecha-YYYY-MM-DD)
            const regex1 = /Fecha-(\d{4}-\d{2}-\d{2})/;
            const match1 = nombreArchivo.match(regex1);

            // Si se encuentra en el primer formato, asignamos la fecha
            if (match1) {
                fecha = match1[1];
            } else {
                // Expresión regular para el segundo formato (YYYYMMDD)
                const regex2 = /-(\d{8})-/;
                const match2 = nombreArchivo.match(regex2);

                // Si se encuentra en el segundo formato, formateamos la fecha
                if (match2) {
                    fecha = match2[1].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
                }
            }

            // Si se ha encontrado la fecha, calculamos el día de la semana
            if (fecha) {
                // Descomponemos la fecha en año, mes y día
                const [year, month, day] = fecha.split('-');
                // Formateamos el día con dos dígitos
                const diaFormateado = day.padStart(2, '0');
                return { fecha, dia: diaFormateado };
            } else {
                return { fecha: this.reporteSelect.fecha, dia: this.reporteSelect.dia };
            }
        },
        CambiarReporte(item) {
            this.selectCambioReporte = item;

            this.modalCambiarReporte = true;
            this.validReporte = false;
        },
        CerrarDialogCambioReporte() {
            this.modalCambiarReporte = false;
            this.valiOracion = '';
            this.oracionValida = '';
            this.validReporte = false;
            this.aleatorio = false;
            this.reporte = '';
        },
        async GuardarCambioReporte() {
            if (this.reporte == '' && this.aleatorio == false) {
                this.validReporte = true;
            }
            if (this.oracionValida != '' && this.validReporte == false) {
                this.oracionValida = this.oracionValida.trim().toLocaleLowerCase()
                const oracion = 'el reporte no se puede calificar'

                if (oracion == this.oracionValida) {
                    this.btndisabledCambio = true;

                    if (this.aleatorio == false) {
                        if (this.reporte == this.selectCambioReporte.nrreporte) {
                            this.$swal({
                                position: 'center',
                                icon: 'info',
                                title: 'Información',
                                text: 'El reporte es el mismo que el que tiene asignado el agente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 5000
                            })
                        } else {
                            this.$swal({
                                title: 'Validando reporte reporte ... ',
                                html: `Espere un momento, por favor`,
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                                didOpen: async () => {
                                    this.$swal.showLoading();
                                    let response = await Calidad.ValidarReporte(this, this.selectCambioReporte.uslogin, this.reporte);
                                    if (response.Validacion == 0) {
                                        this.$swal({
                                            position: 'center',
                                            icon: 'info',
                                            title: 'Información',
                                            text: response.Motivo,
                                            showConfirmButton: true,
                                            allowOutsideClick: false,
                                            timer: 5000
                                        });
                                    } else if (response.Validacion == 1) {
                                        await this.CambioReporte(this.selectCambioReporte.nrreporte, this.selectCambioReporte.svindice, this.selectCambioReporte.uslogin, this.aleatorio, this.reporte);
                                    }
                                }
                            })
                        }
                    } else {
                        await this.CambioReporte(this.selectCambioReporte.nrreporte, this.selectCambioReporte.svindice, this.selectCambioReporte.uslogin, this.aleatorio, this.reporte);

                    }
                    this.btndisabledCambio = false;

                } else {
                    this.valiOracion = 'oración incorrecta'
                }
            } else {
                this.valiOracion = 'campo requerido'
            }
        },
        LimpiarDialogCambioReporte() {
            this.valiOracion = '';
            this.oracionValida = '';
            this.validReporte = false;
            this.reporte = '';
            this.aleatorio = false;
        },
        async CambioReporte(reporte, indice, uslogin, aleatorio, reporteNuevo) {
            let aux = aleatorio == true ? 1 : 0;
            this.$swal({
                title: 'Cambiando reporte ... ',
                html: `Espere un momento, por favor`,
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    let response = await Calidad.CambiarReporte(this, reporte, indice, uslogin, aux, reporteNuevo);
                    if (response[0].Reporte != 0) {
                        this.LimpiarDialogRecalificar();
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se cambio el reporte exitosamente.',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 2500,
                        }).then(async () => {
                            await this.ObtenerAllAgentes();
                            this.CerrarDialogCambioReporte()
                        });
                    } else {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Error',
                            text: 'No se pudo cambiar el reporte ya que el agente no cuenta con mas reportes.',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 5000
                        }).then(async () => {
                            this.CerrarDialogCambioReporte()
                        });
                    }
                }
            })
        },
        /////NUEVO METODO ////
        async monitorProceso(jobId, progressText) {
            return new Promise((resolve) => {
                const interval = setInterval(async () => {
                    let estadoResponse = await Calidad.ObtenerEstadoProceso(this, jobId);
                    //console.log('estadoResponse', estadoResponse)
                    if (estadoResponse && estadoResponse.estado === "Completado") {
                        clearInterval(interval);
                        this.contadorSol++;
                        progressText.innerHTML = `Procesando ${this.contadorSol} de ${this.numReportes} llamadas...`;
                        resolve();
                    }

                    if (estadoResponse && (estadoResponse.estado === "Error" || estadoResponse.estado === "Fallido")) {
                        clearInterval(interval);
                        this.contadorerrores++;
                        this.contadorSol++;
                        progressText.innerHTML = `Procesando ${this.contadorSol} de ${this.numReportes} llamadas...`;
                        resolve();
                    }
                }, 3000); // Polling cada 3 segundos
            });
        }
    },
    async mounted() {
        //Obtener Agentes
        this.showCargando = true;
        await this.ObtenerAllAgentes();
        await this.ObtenerAgentesCalificados()
    }
}
</script>
<style>
.custom-list ol {
    list-style-type: decimal;
    /* Asegura que se muestren los números */
    padding-left: 20px;
    /* Añade algo de sangría para los números */
}

.AgenteCard {
    min-height: 440px !important;
    max-height: 740px !important;
    height: auto;
}

.vue-dropzone .dz-error-message {
    position: absolute;
    top: 0;
    /* Mueve el mensaje hacia la parte superior del cuadro de carga */
    left: 50%;
    transform: translate(5%, -100%);
    background-color: rgba(255, 0, 0, 0.8);
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    z-index: 10;
    /* Asegura que el mensaje esté por encima de otros elementos */
    max-width: 90%;
    text-align: center;
}

.loader-container {
    height: 150px;
}

.auto-margin {
    margin: auto;
    width: min-content;
}
</style>
<style lang="scss">
#Agentes .vs-list--title {
    font-weight: normal;
    text-align: start;
    width: 45vw;
    ;

}

#Agentes #apartado .vs-list--title {
    font-weight: 700;
}

#calificacion {
    font-weight: 700;
    font-size: large;
}

#calificacionFinal {
    font-weight: 800;
    font-size: large;
}

#califFinal .vs-list--title {
    font-weight: 700;
    font-size: x-large;
    color: var(--v-anchor-base);
}

#califFinal .vs-list--title {
    font-weight: 700;
    font-size: x-large;
    color: var(--v-anchor-base);
}

@media (max-width: 500px) {
    #inputCalif {
        width: 100%;
        /* Para pantallas pequeñas, ocupa todo el ancho */
    }
}

@media (min-width: 961px) {
    #inputCalif {
        max-width: 10vh;
        /* Ancho adaptado para pantallas grandes */
    }
}

#area .vs-list--subtitle {
    font-weight: 550;
    font-size: medium;
}
</style>